import Vue from 'vue';
import App from '@/vue/App.vue';
import axios from 'axios';
import router from './router';
import store from './store';
import VueI18n from 'vue-i18n';

// Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';

// Material Design Icon
import '@mdi/font/css/materialdesignicons.css';

Vue.config.productionTip = false;

// Axios をグローバル変数化
Vue.prototype.$http = axios.create(
	{ timeout: 10000 },
);

// 多言語対応
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'jp',
  fallbackLocale: 'jp',
  messages: {
  en: require('@/assets/lang/lang_en.json'),
  jp: require('@/assets/lang/lang_ja.json'),
  },
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
